let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eID6R")).then(() => parcelRequire('6YYOX'));